import axios from 'axios'
import { purchasingTypeUrl, getHeader } from '../config'

const state = {
  purchasingTypeList: []
}

const mutations = {
  SET_PURCHASING_TYPE_LIST (state, obj) {
    state.purchasingTypeList = obj
  }
}

const actions = {
  getPurchasingTypeList: ({ commit }) => {
    axios.get(purchasingTypeUrl, { headers: getHeader() })
      .then(response => {
        commit('SET_PURCHASING_TYPE_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
